import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { resources } from 'constants/locale';
import type { UserConfigs } from 'app/userPreferences/types';

import Config from 'config';
import { AppConstants } from 'constants/index';
import LocalStorageService from 'services/localStorageService';
import {
  I18nResources, LANGUAGES, Namespace,
} from 'app/locale/types';

const defaultNS = 'common';
const { env } = Config;

const getResources = (): I18nResources => Object.fromEntries(
  LANGUAGES.map((lng) => [
    lng,
    Object.fromEntries(
      (Object.keys(resources) as Namespace[]).map((ns) => [
        ns,
        resources[ns][lng],
      ]),
    ),
  ]),
) as I18nResources;

const configs = LocalStorageService.get<UserConfigs>('configs');

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: getResources(),
    fallbackLng: AppConstants.defaultLanguage,
    debug: env !== 'prd',

    ns: Object.keys(resources),
    defaultNS,

    keySeparator: '.',

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: true,
    },

    lng: configs?.languageId ?? AppConstants.defaultLanguage,
  });

export default i18n;
